import { enabledServices, areas } from "@/config/site";

const items = [
  ...enabledServices.map((s) => s.name),
  ...areas.map((a) => `Serving ${a.name}, BC`),
];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((t, i) => (
        <span
          key={`${t}-${i}`}
          className="mx-7 flex items-center gap-7 whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.3em] text-slate-500"
        >
          {t}
          <span className="h-1.5 w-1.5 rounded-full bg-ember" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div className="overflow-hidden border-y border-white/10 bg-slate-950 py-5" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
